import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDateStartFilled = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8 1.25C8.41421 1.25 8.75 1.58579 8.75 2V3.25H15.25V2C15.25 1.58579 15.5858 1.25 16 1.25C16.4142 1.25 16.75 1.58579 16.75 2V3.25H19C20.5192 3.25 21.75 4.48079 21.75 6V19C21.75 20.5192 20.5192 21.75 19 21.75H5C3.48079 21.75 2.25 20.5192 2.25 19V6C2.25 4.48079 3.48079 3.25 5 3.25H7.25V2C7.25 1.58579 7.58579 1.25 8 1.25ZM7.25 4.75H5C4.30921 4.75 3.75 5.30921 3.75 6V8.25H20.25V6C20.25 5.30921 19.6908 4.75 19 4.75H16.75V6C16.75 6.41421 16.4142 6.75 16 6.75C15.5858 6.75 15.25 6.41421 15.25 6V4.75H8.75V6C8.75 6.41421 8.41421 6.75 8 6.75C7.58579 6.75 7.25 6.41421 7.25 6V4.75ZM20.25 9.75H3.75V19C3.75 19.6908 4.30921 20.25 5 20.25H19C19.6908 20.25 20.25 19.6908 20.25 19V9.75Z",
			fill: "#111827"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 4.75H7.25V6C7.25 6.41421 7.58579 6.75 8 6.75C8.41421 6.75 8.75 6.41421 8.75 6V4.75H15.25V6C15.25 6.41421 15.5858 6.75 16 6.75C16.4142 6.75 16.75 6.41421 16.75 6V4.75H19C19.6908 4.75 20.25 5.30921 20.25 6V8.25H3.75V6C3.75 5.30921 4.30921 4.75 5 4.75Z",
			fill: "#111827"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13.5377 13.5377C14.5222 12.5531 15.8576 12 17.25 12C18.2884 12 19.3034 12.3079 20.1667 12.8848C21.0301 13.4617 21.703 14.2816 22.1004 15.2409C22.4977 16.2002 22.6017 17.2558 22.3991 18.2742C22.1966 19.2926 21.6965 20.2281 20.9623 20.9623C20.2281 21.6965 19.2926 22.1965 18.2742 22.3991C17.2558 22.6017 16.2002 22.4977 15.2409 22.1003C14.2816 21.703 13.4617 21.0301 12.8848 20.1667C12.3079 19.3034 12 18.2883 12 17.25C12 15.8576 12.5531 14.5223 13.5377 13.5377ZM16.2573 19.7957C15.924 19.9956 15.5 19.7556 15.5 19.3669V15.1331C15.5 14.7444 15.924 14.5044 16.2573 14.7043L19.7854 16.8212C20.1091 17.0154 20.1091 17.4846 19.7854 17.6788L16.2573 19.7957Z",
			fill: "#111827"
		})
	]
});
const ForwardRef = forwardRef(SvgDateStartFilled);
export default ForwardRef;
